// extracted by mini-css-extract-plugin
export var actionButton = "_8r-1";
export var actionButtons = "_8r-2";
export var actions = "_8r-0";
export var aiUnread = "_8r-10";
export var alignCenter = "_8r-h";
export var backWrapper = "_8r-3";
export var cellContainer = "_8r-4";
export var checkboxContainer = "_8r-5";
export var contentContainer = "_8r-6";
export var contentHeader = "_8r-8";
export var conversationsTableWrapper = "_8r-s";
export var draftReplyBadgeContainer = "_8r-m";
export var dropdownItem = "_8r-b";
export var dropdownItemsContainer = "_8r-a";
export var dropdownTitle = "_8r-c";
export var errorIcon = "_8r-7";
export var filter = "_8r-d";
export var gray = "_8r-i";
export var headerActionButtons = "_8r-e";
export var headerCheckboxContainer = "_8r-f";
export var icon = "_8r-j";
export var menuContainer = "_8r-k";
export var noMoreTicketsIcon = "_8r-12";
export var noMoreTicketsSubText = "_8r-13";
export var oneLine = "_8r-l";
export var optionsButton = "_8r-n";
export var plus = "_8r-o";
export var portalButtonsWrapper = "_8r-g";
export var red = "_8r-p";
export var scrolledTop = "_8r-9";
export var search = "_8r-q";
export var selectedConversationsCount = "_8r-r";
export var spinner = "_8r-t";
export var strong = "_8r-u";
export var summaryCell = "_8r-v";
export var tableContainer = "_8r-11";
export var tagContainer = "_8r-w";
export var threeDots = "_8r-x";
export var twoLines = "_8r-y";
export var unread = "_8r-z";